import { DataFromUrl, REDIRECT, track } from "@/imports-files/common/common";
import router, { useRouter } from "next/router";
import { selectSidebarOptionFromUrl } from "../common/sidebar-values";
import { closeHamburgerMenuElement } from "./hamburger-menu";
import { WebsiteCookies } from '@/actions/common/website-cookies';

export function setSubMenuStatus(element, queryClient)
{
    // These lines stop the x axis scrolling . this need to be check when nested menu is created for website
    element.stopPropagation();
 
    if(element.currentTarget.classList.contains('Close') && element.currentTarget.closest('.ChildSubSidebarItem') == null )
    {
        close_other_options(queryClient);
        element.currentTarget.classList.remove('Close');
        element.currentTarget.classList.add('Open');
        add_color_class(queryClient);
    }
    else if(element.currentTarget.classList.contains('Open') && element.currentTarget.closest('.ChildSubSidebarItem') == null)
    {
        element.currentTarget.classList.remove('Open');
        element.currentTarget.classList.add('Close');
    }   
    
    // setSubSidebarOptionsPosition(element.currentTarget);
}

// export function setSubSidebarOptionsPosition(element)
// {
    
//     if( element.classList.contains('Close') && element.getElementsByClassName('ChildSubSidebarItem')[0] )
//     { 
//         document.querySelector('.Page.Dashboard').style.overflowX                  =    null; 
//         document.querySelector('.MobileSubMenuBar .SubSidebar').style.overflowX    =    'scroll'; 
//         showAllItems();
//      }
//     else if( element.classList.contains('Open') && element.getElementsByClassName('ChildSubSidebarItem')[0] )
//     { 
//         document.querySelector('.Page.Dashboard').style.overflowX                   =   'hidden';
//         document.querySelector('.MobileSubMenuBar .SubSidebar').style.overflowX     =   null; 
//         hideAllItems();
//         showItems(element);
        
//     }
//     else 
//     {
//         document.querySelector('.Page.Dashboard').style.overflowX                   =   null;
//         document.querySelector('.MobileSubMenuBar .SubSidebar').style.overflowX     =   'scroll'; 
//         showAllItems();
//         var getItemPosition                             =    getSelectedItemPosition(element);
//         document.querySelector('.MobileSubMenuBar .SubSidebar').scroll( {top:0, left: (getItemPosition.left - screen.width/3), behavior: 'smooth' });

//     }

// }

function showItems(element)
{
    element.style.display   =   "grid";
    var itemPosition        =   parseInt(element.getAttribute('item-index'));
    var subItemLength       =   document.querySelectorAll('.MobileSubMenuBar .SubSidebar .SubSidebar__List > .SubSidebarItem').length
    
    if(itemPosition == 0 && subItemLength)
    {
        let nextElement                              =     element.nextElementSibling;
        nextElement.style.display                    =     "grid";
        nextElement.nextElementSibling.style.display =     "grid";
        document.querySelector('.MobileSubMenuBar .SubSidebar').scroll( {top:0, left: 0, behavior: 'smooth' });
    }
    else if(itemPosition == subItemLength-1)
    {
        let previousElement                                    =     element.previousElementSibling;
        previousElement.style.display                          =     "grid";
        previousElement.previousElementSibling.style.display   =     "grid";
        document.querySelector('.MobileSubMenuBar .SubSidebar').scroll( {top:0, left: document.getElementsByClassName('SubSidebar')[1].scrollWidth, behavior: 'smooth' });
    }
    else
    {
        element.nextElementSibling.style.display        =     "grid";
        element.previousElementSibling.style.display    =     "grid";
        var getItemPosition                             =    getSelectedItemPosition(element);
        document.querySelector('.MobileSubMenuBar .SubSidebar').scroll( {top:0, left: (getItemPosition.left - screen.width/3), behavior: 'smooth' });
    }
    
}

export function hideAllItems()
{
    var elements = document.querySelectorAll('.MobileSubMenuBar .SubSidebar .SubSidebar__List > .SubSidebarItem');
    elements.forEach( (element) => {
                                        element.style.display = 'none';
                                   })
}

export function showAllItems()
{
    var elements = document.querySelectorAll('.MobileSubMenuBar .SubSidebar .SubSidebar__List > .SubSidebarItem');
    elements.forEach( (element) => {
                                        element.style.display = 'grid';
                                   })
}

export function getSelectedItemPosition(element)
{
    var left = element.offsetLeft;
    var mobileMenubar = document.getElementsByClassName('MobileSubMenuBar')[0];
    var top = mobileMenubar.offsetHeight + mobileMenubar.offsetTop;
    var position = { 'left':left, 'top':top};
    return  position;
}

export function redirectToCareerPage(){
  let career_page_url     =  REDIRECT.client.career_site.customize;
  let protocol       =  window.location.protocol;
  let host           =  window.location.host;
  let url            =  protocol + '//' + host + career_page_url;
  window.open(url, '_blank')
}

export function redirectToInboxPage(){
  let comm_page_url     =  REDIRECT.client.communication.inbox;
  let protocol       =  window.location.protocol;
  let host           =  window.location.host;
  let url            =  protocol + '//' + host + comm_page_url;
  window.open(url, '_self')
}

export function redirectToSentPage(){
  let comm_page_url     =  REDIRECT.client.communication.sent;
  let protocol       =  window.location.protocol;
  let host           =  window.location.host;
  let url            =  protocol + '//' + host + comm_page_url;
  window.open(url, '_self')
}

export async function redirectToOtherPage(Options, router, navbarStatus, updateNavbarStatus)
{
    if(Options.link && (Options.link == REDIRECT.client.career_site.customize))
    {
        redirectToCareerPage()
        return
    }
    if(Options.link && (Options.link == REDIRECT.client.communication.inbox))
    {
        redirectToInboxPage()
        return
    }

    if(Options.link && (Options.link == REDIRECT.client.communication.sent))
    {
        redirectToSentPage()
        return
    }

    var value = await selectSidebarOptionFromUrl( Options.link, navbarStatus );
    await updateNavbarStatus(value);
    if(Options.link)
    {
        if(Options.link.includes('reports')){
            const eventProperties = {
              'Report Title': Options.title,
            };
            track('Report Viewed', eventProperties);
        }

        router.push(Options.link);
    }
}

export function redirectToOtherStep(event, queryClient, Options, router )
{
    var link = null;
    if(Options.link.includes('/jobs/$job_id/'))
    {
        link = insert_id_in_link(Options, queryClient, 'job-step');
        link = router.query.from_kanban ? (link + "?from_kanban=true") : link
    }
    else if(Options.link.includes('/clients/$client_id/'))
    {
        link = insert_id_in_link(Options, queryClient, 'onboarding-step');
    }
    else if(Options.link.includes('clients/activities/quick-setup'))
    {
        link = Options.link;
    }

    if(link)
    {
        router.push(link);
    }
}

export function activeOnHover(event, queryClient, Options )
{
    var link = null;
    
    if(Options.link.includes('/jobs/$job_id/'))
    {
        link = insert_id_in_link(Options, queryClient, 'job-step');
    }
    else if(Options.link.includes('/clients/$client_id/'))
    {
        link = insert_id_in_link(Options, queryClient, 'onboarding-step');
    }


    if(link)
    {
        event.currentTarget.getElementsByClassName('SubSidebarItem__Bullets')[0].classList.add('Active');
        event.currentTarget.getElementsByClassName('SubSidebarItemText')[0].classList.add('Active');
        
    }
    else
    {
        event.currentTarget.getElementsByClassName('SubSidebarItem__Bullets')[0].classList.remove('Active');
        event.currentTarget.getElementsByClassName('SubSidebarItemText')[0].classList.remove('Active');   
    }
}


export function insert_id_in_link(Option, queryClient, step_name, router)
{
    var data_from_url   =   new DataFromUrl();
    let idRegex         =   new RegExp("[0-9]")
    let link            =   Option.link
    let job_step        =   queryClient.getQueryData(step_name) || 0;
    let job_status      =   queryClient.getQueryData('job-status') || 'draft';

    if( link.includes('/jobs/$job_id/') && ((Option.step) <= job_step) && job_status != "draft")
    {   
        let job_id = data_from_url.getJobId();
        return idRegex.test(job_id) ? link.replace('$job_id', job_id) : null;
    }
    else if( link.includes('/admins/clients/$client_id/') && ((Option.step) <= job_step) )
    {
        let client_id = data_from_url.getClientId();
        return link.replace('$client_id', client_id) ;
    }
    else if( link.includes('/clients/$client_id/') && ((Option.step) <= job_step) )
    {
        let client_id = data_from_url.getClientId();
        return idRegex.test(client_id) ? link.replace('$client_id', client_id) : null;
    }
    //INFO:- Other links that does not contains id
    else if(!link.includes('/$'))  
    {
        return link;
    }
    else
    {
        return null;
    }
}


export function mobileRedirectToOtherPage(queryClient, Options, loadPageInDashboard, setPageName )
{
    var key         = event.target.title;
    var parent_key  = queryClient.getQueryData('selectedParentSubSidebarOptions');
    queryClient.setQueryData('selectedSubSidebarOptions', () => key);
    queryClient.setQueryData('selectedParentSubSidebarOptions', () => parent_key);
    loadPageInDashboard(queryClient, setPageName);
    setPageName(key);
    hide_dropdown_sidebar();
    window.history.replaceState(null, null, Options.link);
}



export function close_other_options(queryClient)
{
    let elements = document.querySelectorAll('.ParentSubSidebarItem');
    
    elements.forEach(element => {
                                        element.classList.contains('Open')
                                        {
                                            element.classList.remove('Open');
                                            element.classList.add('Close');
                                        }
                                    });
    remove_color_class();
}


export function mobileActivateOption( queryClient, value, subSidebarOptions, setSubSubSidebarOptions )
{
    
    var dropdown_menu           =   document.getElementsByClassName('MobileDropdownSuboption')[0];
    var previous_element_name   =   queryClient.getQueryData('selectedParentSubSidebarOptions');

    if(previous_element_name != value)
    {
        hide_dropdown_sidebar();
    }
    
    if( (subSidebarOptions) && (!dropdown_menu.classList.contains('Open')) )
    {
        show_dropdown_sidebar();
    }
    else
    {
        hide_dropdown_sidebar();
    }

    remove_color_class();
    queryClient.setQueryData('selectedParentSubSidebarOptions', value);
    add_color_class(queryClient);
    setSubSubSidebarOptions(subSidebarOptions);
}



export function add_color_class(queryClient)
{
    var title = queryClient.getQueryData('selectedParentSubSidebarOptions');
    var element = document.querySelectorAll('[data-item-title= "'+title+'"')[0];

    if(element!=undefined)
    {
        Array.from(element.parentElement.children).forEach((ele) => {
            
                                                                        if(ele.classList.contains('SubSidebarItemText'))
                                                                        {
                                                                            ele.classList.add('color-skyblue');
                                                                            ele.getElementsByTagName('path')[0] != undefined ? ele.getElementsByTagName('path')[0].style.fill="#ffffff" :  '';
                                                                        }
                                                                        else
                                                                        {
                                                                            Array.from(ele.children).forEach((childEle) => {
                                                                                                                                childEle.classList.add('color-white');
                                                                                                                            })
                                                                        }
                                                                    })
    }
}

export function remove_color_class()
{
    var colors = document.querySelectorAll(".SubSidebar .color-skyblue");
    if(colors!=undefined)
    {
        Array.from(colors).forEach((ele) => 
        {
            ele.classList.remove('color-skyblue');
            ele.getElementsByTagName('path')[0] != undefined ? ele.getElementsByTagName('path')[0].style.fill="#99ADBD" :  '';
        })
    }
}

export function hide_dropdown_sidebar()
{
    document.getElementsByClassName('MobileDropdownSuboption')[0].classList.remove('Open');
}

export function show_dropdown_sidebar()
{
    document.getElementsByClassName('MobileDropdownSuboption')[0].classList.add('Open');
    closeHamburgerMenuElement();
}
